import { type MutableRefObject, useLayoutEffect, useRef } from 'react';

export const useLatest = <T>(value: T): MutableRefObject<T> => {
  const valueRef = useRef<T>(value);
  useLayoutEffect(() => {
    valueRef.current = value;
  }, [value]);
  return valueRef;
};
